import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { inject, bind } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';
import * as ApiTypes from '../../models/ApiTypes';
import { Button } from 'react-bootstrap';
import FaIcon from '../site/FaIcon';

interface IObjektAnlegenHeaderProps {
  caption: string;
  showModal: () => void;
}

/** Header für das Panel zur Objektanlage mit Funktionen je nach Anwenderstufe  */
export class ObjektAnlegenHeader extends React.Component<IObjektAnlegenHeaderProps> {

  @inject(UiStore) uiStore: UiStore;

  render() {
    const portalAdmin = this.uiStore.userProfile && this.uiStore.userProfile.portaladmin;
    if (portalAdmin) {
      // Portaladministratoren (=interne Mitarbeiter) dürfen Daten aus ÜO Messmitteln übernehmen
      return (
        <div>
          <div className="panel-title pull-left">
            {this.props.caption}
          </div>
          <div className="panel-title pull-right">
              <Button bsStyle="default" onClick={this.props.showModal}><FaIcon icon="wrench" /> Aus Messmittel</Button>
          </div>
          <div className="clearfix"/>
        </div>
      );
    } else {
      return (
        <div>
          <div className="panel-title pull-left">
            {this.props.caption}
          </div>
          <div className="clearfix"/>
        </div>
      );
    }
  }
}

interface IObjektAnlegenProps {
  onAddObjekt?: (objekt: Partial<ApiTypes.IObjekt>) => void;
}

/** Basisklasse für Komponenten zum Anlegen von neuen Objekte - Nicht direkt verwenden */
@observer
export default class ObjektAnlegen extends React.Component<IObjektAnlegenProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  @observable objektVorlagen: ApiTypes.IObjektVorlage[];
  @observable objektVorlagenTypen: ApiTypes.IObjektVorlage[];
  @observable objektVorlagenHersteller: string[] = [];

  @observable modalVisible: boolean = false;

  @bind @action showModal() {
    this.modalVisible = true;
  }

  @bind @action hideModal() {
    this.modalVisible = false;
  }

  @action setObjektVorlagen(objektVorlagen: ApiTypes.IObjektVorlage[]) {
    this.objektVorlagen = objektVorlagen;
    // Liste der Hersteller aus Vorlagen extrahieren
    this.objektVorlagenHersteller = [];
    if (this.objektVorlagen) {
      // Liste mit eindeutigen Herstellervorlagen
      this.objektVorlagen.forEach(element => {
        if (this.objektVorlagenHersteller.indexOf(element.hersteller) === -1) {
          this.objektVorlagenHersteller.push(element.hersteller);
        }
      });
    }
  }

  // Liefert die Liste aller Typen für den angegebenen Hersteller zurück
  vorlagenZuHersteller(hersteller?: string) {
    // Schreibweise vom Hersteller darf keine Rolle spielen, z.B. wegen Datenübernahme aus dem ÜO Umfeld
    if (hersteller) {
      return this.objektVorlagen.filter(vorlage => vorlage.hersteller.toLocaleLowerCase() === hersteller.toLocaleLowerCase());
    } else {
      return [];
    }
  }

  // Liefert eine Objektvorlage für den gegebenen Hersteller und Typbezeichner
  vorlageZuModell(hersteller?: string, bezeichner?: string) {
    if ((hersteller) && (bezeichner)) {
      return this.objektVorlagenTypen.find(el => ((el.hersteller.toLocaleLowerCase() === hersteller.toLocaleLowerCase()) && (el.modell.toLocaleLowerCase() === bezeichner.toLocaleLowerCase())));
    } else {
      return null;
    }
  }

  // Liefert den Wert eines in der Vorlage hinterlegten Metadatums
  vorlageMetaDatum(vorlage: ApiTypes.IObjektVorlage, kategorie: string, detail?: string) {
    if (vorlage) {
      let metadatum = vorlage.meta.find((meta) => meta.kategorie === kategorie && (meta.detail === detail || meta.detail === ''));
      if (metadatum) {
        return metadatum.wert;
      }
    }
    return '';
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/objekte/ObjektAnlegen.tsx